/* eslint-disable no-bitwise */

export default class Color {
  // ================================================================================================
  // properties
  // ================================================================================================
  red: number;

  green: number

  blue: number;

  value: number;

  redRatio: number;

  greenRatio: number;

  blueRatio: number;

  // ================================================================================================
  // public
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  constructor(value?: number | string) {
    if (!this.setColor(value)) {
      this.red = 0;
      this.green = 0;
      this.blue = 0;
      this.update();
    }
  }

  // ----------------------------------------------------------------------------------------------
  static Create(value?: number | string): Color {
    return (new Color(value));
  }

  // ----------------------------------------------------------------------------------------------
  /**
   * Converts a hex string color to its numerical counterpart. RGB is surrportd; no alpha channel.
   * @param hex {string} - The RGB format string to convert. It can begin with an optional
   * `0x` or `#`.
   * @returns {number} - The converted number, or -1 if the hex string could not be converted.
   */
  hexStringToColor(hex: string): number {
    if (!hex) {
      return (-1);
    }

    hex = hex.replace(/^(?:#|0x)?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m: string, r: string, g: string, b: string) => (r + r + g + g + b + b));

    const result = (/^(?:#|0x)?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i).exec(hex);
    if (!result) {
      return (-1);
    }

    this.red = Number.parseInt(result[1], 16);
    this.green = Number.parseInt(result[2], 16);
    this.blue = Number.parseInt(result[3], 16);

    this.update();
    return (this.value);
  }

  // ----------------------------------------------------------------------------------------------
  numericalToColor(color: number): number {
    this.red = (color & 0xff0000) >> 16;
    this.green = (color & 0xff00) >> 8;
    this.blue = color & 0xff;

    this.update();
    return (this.value);
  }

  // ----------------------------------------------------------------------------------------------
  setColor(color: number | string): boolean {
    if (typeof color === 'string') {
      this.hexStringToColor(color);
      return (true);
    }

    if (typeof color === 'number') {
      this.numericalToColor(color);
      return (true);
    }

    return (false);
  }

  // ----------------------------------------------------------------------------------------------
  update(): void {
    this.value = (this.red << 16) | (this.green << 8) | this.blue;

    this.redRatio = this.red / 255;
    this.greenRatio = this.green / 255;
    this.blueRatio = this.blue / 255;
  }
}
